// extracted by mini-css-extract-plugin
export default {"userImage":"avatar_userImage__H15o3","username":"avatar_username__bYZtV","userNote":"avatar_userNote__9QdJz"};